define('../app/fukit/view/base.page.view',['require','exports','module','underscore','marionette','backbone','uikit/uikit','templates'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      Mn        = require('marionette'),
      Backbone  = require('backbone'),
      UIKit     = require('uikit/uikit'),
      Templates = require('templates');

  var BasePageView = UIKit.ItemView.extend({
    // the class of the root element inside template, under which view will be inserted
    className: 'page',
  });

  module.exports = BasePageView;
});

